
import Vue from 'vue';
import { CvIconButton } from '@carbon/vue';
import { PropType } from 'vue';
import { Tool } from '../../typings';
import CustomPanSvg from './CustomPanSvg.vue';
import CustomCursorSvg from './CustomCursorSvg.vue';
import { mapState } from 'pinia';
import { useStore as useHistoryStore } from '@/stores/history';
import { useStore as useProductStore } from '@/stores/product';

import Bar24 from '@carbon/icons-vue/es/bar/24';

export default Vue.extend({
  components: {
    CvIconButton,
    CustomPanSvg,
    CustomCursorSvg,
    Bar24,
  },
  props: {
    tool: {
      type: Object as PropType<Tool>,
      required: true,
    },
  },
  data() {
    return {
      lanyardIconSrc: require('../../../../assets/lanyard-icon.png'),
    };
  },
  computed: {
    ...mapState(useHistoryStore, ['isUndoPossible', 'isRedoPossible']),
    ...mapState(useProductStore, ['unavailablePrintPositions']),
    isToolDisabled(): boolean {
      if (this.tool.label === 'apply-history-back-control') {
        return !this.isUndoPossible;
      }

      if (this.tool.label === 'apply-history-forward-control') {
        return !this.isRedoPossible;
      }

      if (
        this.tool.label === 'apply-text-control' ||
        this.tool.label === 'apply-modal-control'
      ) {
        return this.unavailablePrintPositions.length === 0;
      }

      return false;
    },
  },
});
